import { jsonldInstructions } from './JsonldStore';

export const updateJsonldInstructions = (value) => jsonldInstructions.update((oldValue) => value);
